import { createApiEffect } from '@/features/api/common/create-api-effect'
import { TableDataResponse } from '@/features/api/types'
import { GetTicketsListQueryParams, ModerationTicket } from '@/features/api/ticket/types'

export const getTicketsListFx = createApiEffect<
  GetTicketsListQueryParams,
  TableDataResponse<ModerationTicket[]>
>({
  requestMapper: (query) => ({
    method: 'GET',
    url: '/api/ticket-app/moderation-ticket/list/',
    query,
  }),
})
